module.exports = __webpack_public_path__ + "static/media/registration.1172d824.mp4";